import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Table, Divider, Button, message, Select, Spin } from "antd";
import { PlusSquareOutlined } from "@ant-design/icons";
import {
  convertDeviceList,
  convertDependentDeviceListToApiValues,
} from "../../Helpers/DeviceHelpers";
import { apiCallback } from "../../ApiHandlers/Common";
import { defaultSort, selectFilterFunction } from "../../Constants/Utilities";
import { convertDeviceModelListToDropdown } from "../../Helpers/DeviceModelHelpers";
import { BreadCrumbs } from "../Common/BreadCrumbs";

class DeviceAssign extends React.Component {
  constructor(props) {
    super(props);
    console.log("DeviceAssign props", props);
    this.state = {
      deviceModelData: [],
      fetchingDeviceModelData: false,
      selectedModel: undefined,
      deviceData: [],
      fetchingDeviceData: false,
      processing: false,
      selectedRows: [],
      columns: [
        {
          title: "Device ID",
          dataIndex: "deviceId",
          sorter: (a, b) => defaultSort(a.deviceId, b.deviceId),
          defaultSortOrder: "ascend",
        },
        {
          title: "Device Model",
          dataIndex: "modelNumber",
          sorter: (a, b) => defaultSort(a.modelNumber, b.modelNumber),
        },
        {
          title: "Base MAC Address",
          dataIndex: "baseMacAddress",
        },
        {
          title: "Software Version",
          dataIndex: "softwareVersion",
        },
      ],
    };
  }

  componentDidMount() {
    this.fetchDeviceModelData();
  }

  fetchDeviceModelData() {
    console.log("fetchDeviceModelData...");
    const { history, deviceModelApi } = this.props;
    this.setState({ fetchingDeviceModelData: true });
    const errorCallback = () => {
      this.setState({ fetchingDeviceModelData: false });
      message.error("Error fetching Device Model list!");
    };
    const successCallback = (data) => {
      const deviceModelData = convertDeviceModelListToDropdown(data);
      console.log("fetchDeviceModelData data", deviceModelData);
      this.setState({ deviceModelData, fetchingDeviceModelData: false });
    };
    try {
      deviceModelApi.getDeviceModels(
        apiCallback({ history, errorCallback, successCallback })
      );
    } catch (error) {
      errorCallback();
    }
  }

  /* fetch unassgined devices for given model */
  fetchDeviceData(modelId) {
    console.log("fetchDeviceData...", modelId);
    const errorCallback = () => {
      this.setState({ fetchingDeviceData: false });
      message.error("Error fetching Device list!");
    };
    const successCallback = (data) => {
      const deviceData = convertDeviceList(data);
      console.log("fetchDeviceData data", deviceData);
      this.setState({ deviceData, fetchingDeviceData: false });
    };
    try {
      this.setState({ fetchingDeviceData: true });
      const { history, deviceApi } = this.props;
      const deviceModelId = modelId || this.state.selectedModel;
      deviceApi.getDeviceByModelIdUnAssigned(
        deviceModelId,
        apiCallback({ history, errorCallback, successCallback })
      );
    } catch (error) {
      errorCallback();
    }
  }

  onDeviceModelChange = (value) => {
    console.log("onDeviceModelChange", value);
    this.setState({ selectedModel: value });
    value && this.fetchDeviceData(value);
  };

  onDeviceAssign = () => {
    const errorCallback = (error) => {
      this.setState({ processing: false });
      message.error("Error assigning Devices!");
    };
    const successCallback = (data) => {
      message.success("Devices assinged successfully!");
      this.setState({ processing: false, selectedRows: [] });
      this.fetchDeviceData(); /* refetch unassigned device */
    };
    try {
      this.setState({ processing: true });
      const { selectedRows } = this.state;
      console.log("onDeviceAssign...", selectedRows);
      const { record, history, serviceProviderApi } = this.props;
      const deviceData = convertDependentDeviceListToApiValues(selectedRows);
      console.log("onDeviceAssign deviceData", deviceData);
      serviceProviderApi.assignDevicesToServiceProvider(
        record.providerId,
        deviceData,
        apiCallback({
          history,
          errorCallback,
          failCallback: errorCallback,
          successCallback,
        })
      );
    } catch (error) {
      errorCallback(error);
    }
  };

  render() {
    const {
      columns,
      processing,
      selectedRows,
      deviceModelData,
      fetchingDeviceModelData,
      selectedModel,
      deviceData,
      fetchingDeviceData,
    } = this.state;
    const { record, onActionClick, parentBread } = this.props;
    return (
      <div className="entity-list-container">
        <div className="page-header-container">
          <BreadCrumbs
            headers={parentBread.concat(`Assign Device`)}
            onParentActionClick={onActionClick(null, null)}
          />
        </div>
        <Divider className="divider" />
        <div className="page-parent-title-container">
          <label>Service Provider: {record.name}</label>
        </div>
        <Spin spinning={processing} tip="Assigning Devices, please wait...">
          <div className="search-add-container">
            <div className="search-container">
              <span className="search-label">Device Model:</span>
              <Select
                showSearch
                allowClear
                value={selectedModel}
                loading={fetchingDeviceModelData}
                disabled={fetchingDeviceModelData}
                onChange={this.onDeviceModelChange}
                filterOption={selectFilterFunction}
                style={{ minWidth: "250px", maxWidth: "300px" }}
                placeholder={
                  fetchingDeviceModelData
                    ? "Loading Device Models..."
                    : "Select Device Model"
                }
              >
                {deviceModelData?.map((item) => (
                  <Select.Option key={item.modelId} title={item.modelNumber}>
                    {item.modelNumber}
                  </Select.Option>
                ))}
              </Select>
            </div>
            <div className="add-container">
              <Button
                type="primary"
                icon={<PlusSquareOutlined />}
                onClick={this.onDeviceAssign}
                disabled={!selectedRows.length}
                title={
                  selectedRows.length
                    ? `Assign ${selectedRows.length} Devices`
                    : "Select Devices to Assign"
                }
              >
                Assign ({selectedRows.length})
              </Button>
            </div>
          </div>
          {!selectedModel ? (
            <div className="no-entity-warning">
              <div className="warning-label">
                Select any Device Model to view Device List
              </div>
            </div>
          ) : (
            <Table
              bordered
              size="small"
              columns={columns}
              dataSource={deviceData}
              className="entity-table"
              loading={fetchingDeviceData && { tip: "Fetching Device list..." }}
              rowSelection={{
                onChange: (_, selectedRows) => this.setState({ selectedRows }),
                getCheckboxProps: (record) => ({
                  name: record.name,
                  disabled: false,
                }),
              }}
            />
          )}
        </Spin>
      </div>
    );
  }
}

DeviceAssign.propTypes = {
  record: PropTypes.object,
  onActionClick: PropTypes.func,
  parentBread: PropTypes.array,

  deviceApi: PropTypes.object,
  deviceModelApi: PropTypes.object,
  serviceProviderApi: PropTypes.object,
};

const mapStateToProps = (state) => ({
  deviceApi: state.apis.deviceApi,
  deviceModelApi: state.apis.deviceModelApi,
  serviceProviderApi: state.apis.serviceProviderApi,
});
const connectedDeviceAssign = connect(mapStateToProps)(DeviceAssign);
export default withRouter(connectedDeviceAssign);
